import {
  FETCH_DISCOUNTS_DATA,
  FETCH_DISCOUNTS_SUCCESS,
  FETCH_DISCOUNTS_FAILURE,
  FETCH_DISCOUNTS_EDIT_DATA,
  FETCH_DISCOUNTS_EDIT_SUCCESS,
  FETCH_DISCOUNTS_EDIT_FAILURE,
} from "./actionTypes";

export const fetchDiscountsData = () => ({
  type: FETCH_DISCOUNTS_DATA,
});

export const fetchDiscountsSuccess = (data) => ({
  type: FETCH_DISCOUNTS_SUCCESS,
  payload: data,
});

export const fetchDiscountsFailure = (error) => ({
  type: FETCH_DISCOUNTS_FAILURE,
  payload: error,
});

export const fetchDiscountsEditData = (id) => ({
  type: FETCH_DISCOUNTS_EDIT_DATA,
  payload: id,
});

export const fetchDiscountsEditSuccess = (data) => ({
  type: FETCH_DISCOUNTS_EDIT_SUCCESS,
  payload: data,
});

export const fetchDiscountsEditFailure = (error) => ({
  type: FETCH_DISCOUNTS_EDIT_FAILURE,
  payload: error,
});
